module.exports = __webpack_public_path__ + "static/media/icon-parent-late.a0bcb5c4.svg";